/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolNightlightIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-nightlight"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.72 22.8Q11.47 22.8 9.51 21.95Q7.55 21.1 6.09 19.64Q4.63 18.18 3.77 16.21Q2.92 14.25 2.92 12Q2.92 9.75 3.77 7.79Q4.63 5.83 6.09 4.36Q7.55 2.9 9.51 2.05Q11.47 1.2 13.72 1.2Q14.82 1.2 15.88 1.41Q16.93 1.63 17.93 2.08Q18.3 2.25 18.5 2.58Q18.7 2.9 18.7 3.27Q18.7 3.6 18.55 3.89Q18.4 4.17 18.1 4.38Q16.23 5.65 15.3 7.69Q14.38 9.72 14.38 12Q14.38 14.28 15.28 16.32Q16.18 18.38 18.05 19.63Q18.35 19.82 18.5 20.13Q18.65 20.43 18.65 20.75Q18.65 21.13 18.45 21.45Q18.25 21.77 17.88 21.95Q16.9 22.4 15.85 22.6Q14.8 22.8 13.72 22.8Z" fill={color} />
    </svg>
  );
}
